import { render, staticRenderFns } from "./cg-misc.vue?vue&type=template&id=db2fcd02&scoped=true"
import script from "./cg-misc.vue?vue&type=script&lang=js"
export * from "./cg-misc.vue?vue&type=script&lang=js"
import style0 from "./cg-misc.vue?vue&type=style&index=0&id=db2fcd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2fcd02",
  null
  
)

export default component.exports